import { Accordion, ButtonText } from '@morressier/alembic';
import { faArrowRotateLeft, faBell } from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { IconBadge } from 'src/components/IconBadge';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { UnsubmitContextModal } from 'src/components/Submission/modals/UnsubmitContextModal';
import AdditionalInformationWrapper from '../../AdditionalInformationWrapper';

export const EditorialUnsubmittedAdditionalInfo = () => {
  const { unsubmit } = useSubmissionData();
  const [showContextModal, setShowContextModal] = useState(false);

  return (
    <AdditionalInformationWrapper>
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: 0
        }}
        items={[
          {
            title: (
              <Flex alignItems={'flex-start'} gap={2}>
                <IconBadge icon={faBell} variant="neutral" />
                <Flex flexDirection={'column'} marginLeft={2}>
                  <Text textStyle="headingItem">Highlights</Text>
                  <Text textStyle="textContext">
                    Review key updates and other relevant information in this
                    phase.
                  </Text>
                </Flex>
              </Flex>
            ),
            content: (
              <Flex flexDirection="column" width="100%" gap={4}>
                <Flex gap={3} alignItems="start">
                  <IconBadge icon={faArrowRotateLeft} variant="attention" />
                  <Flex flexDirection="column" flex={1}>
                    <Text textStyle="headingItem">Submission Unsubmitted</Text>
                    <Text>
                      The author received this Submission back as a draft to
                      make structural improvements.
                    </Text>
                  </Flex>
                  <ButtonText
                    marginLeft="auto"
                    onClick={() => setShowContextModal(true)}
                  >
                    View Details
                  </ButtonText>
                </Flex>
              </Flex>
            )
          }
        ]}
      />

      {showContextModal && (
        <UnsubmitContextModal
          data={unsubmit}
          onClose={() => setShowContextModal(false)}
        />
      )}
    </AdditionalInformationWrapper>
  );
};
